import '../util/aria.js';
import { LitElement, html, property, customElement } from 'lit-element';
import { cssResult } from '../util/css.js';
import { __decorate, __metadata } from 'tslib';
import { sharedStyles } from '../style/shared.js';
import styles from './text.scss.js';

let Text = class Text extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.role = 'paragraph';
    }
    render() {
        return html` <slot></slot> `;
    }
};
Text.styles = [
    sharedStyles,
    cssResult(styles)
];
__decorate([
    property({
        type: String,
        reflect: true
    }),
    __metadata('design:type', String)
], Text.prototype, 'size', void 0);
__decorate([
    property({
        type: String,
        reflect: true
    }),
    __metadata('design:type', String)
], Text.prototype, 'role', void 0);
Text = __decorate([customElement('wl-text')], Text);

export { Text };
